<template>
    <div :class="editing ? 'border border-gray-300 bg-gray-warm-50 rounded-md px-6 py-5' : 'border-b border-gray-200 pb-5'">
        <h2 class="text-gray-400 text-lg font-semibold">
            Documents
        </h2>

        <p v-if="! selected_documents.length"
            class="text-base text-gray-500 mb-3"
        >
            Select one or more documents from your Document Library to include in this Envelope
        </p>

        <div v-else class="pt-3">
            <div v-for="document in selected_documents"
                :key="document.id"
                class="flex items-start py-1.5 pl-8"
            >
                <file-icon size="16"
                    class="flex-none mr-2 mt-1"
                    :class="editing ? 'text-blue-600' : 'text-black'"
                    :stroke-width="2"
                    fill="none"
                />

                <div class="font-semibold text-md leading-snug select-none"
                    :class="editing ? 'text-blue-600' : 'text-black'"
                >
                    {{ document.display_filename }}
                </div>

                <div v-if="editing"
                    class="cursor-pointer hover:text-red-600 items-center text-gray-300 ml-3"
                    @click="removeDocument(document)"
                >
                    <i class="fas fa-minus-circle"></i>
                </div>
            </div>
        </div>

        <div v-if="editing"
            class="w-full flex justify-end"
        >
            <button type="button"
                class="flex flex-none py-1 text-blue-600 hover:text-blue-800 cursor-pointer leading-none items-end outline-none"
                @click="addDocument"
            >
                <div class="text-md font-semibold leading-none text-label">
                    <span class="text-lg mr-0.5 pt-1.5">+</span>

                    {{ $t('Select documents') }}
                </div>
            </button>
        </div>

        <document-select-modal
            :show="selecting_documents"
            :documents="all_documents"
            :folders="folders"
            :selected_ids="selected_ids_proxy"
            @closed="selectDocumentModalClosed"
            @selected="selectDocuments"
        />
    </div>
</template>

<script>
import DocumentSelectModal from '../document-select-modal.vue';
import { FileIcon } from 'vue-feather-icons';

export default {
    components: {
        DocumentSelectModal,
        FileIcon,
    },

    props: {
        all_documents: { default: () => [] },
        folders: { default: () => [] },
        selected_document_ids: { default: () => [] },
        value: { default: () => [] },
        editing: { default: false },
    },

    computed: {
        selected_documents() {
            return this.all_documents.filter(document => this.selected_ids_proxy.includes(document.id))
        },
    },

    data() {
        return {
            selected_ids_proxy: [],
            selecting_documents: false,
        }
    },

    methods: {
        addDocument() {
            this.selecting_documents = true;
        },
        selectDocuments(selected) {
            this.selected_ids_proxy = [...selected];
            this.selecting_documents = false;
        },
        selectDocumentModalClosed() {
            this.selecting_documents = false;
        },
        removeDocument(document_to_remove) {
            this.selected_ids_proxy.splice(
                this.selected_ids_proxy.findIndex(document_id => document_id == document_to_remove.id), 1
            );
        },
    },

    created() {
        this.selected_ids_proxy = this.selected_document_ids;
    },

    watch: {
        selected_ids_proxy: {
            deep: true,
            handler(value) {
                this.$emit('input', value);
            },
        },
    },
}
</script>
